<template>
  <div class="wait_buy">
    <div class="topBar">
      <div class="subTitle">
        <i class="far fa-window-minimize icon_I"></i>
        等待采购列表
        <div @click="setPage(1)" class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div class="margin_left_x">刷新</div>
        </div>
      </div>
    </div>
    <div v-if="role" class="content_box">
      <div class="table_title">
        <div class="table_title_box">
          <div class="title_icon">
            <i class="fas fa-bars"></i>
          </div>
          <div class="title_text">数据列表</div>
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
          <el-table-column prop="orderCode" width="200" label="订单编号" align="center"></el-table-column>
          <el-table-column width="500" label="商品信息" >
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.product_list" :key="index">{{item.title}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" width="170" label="下单时间" align="center"></el-table-column>
          <el-table-column prop="finance_check" width="100" label="审核" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                size="small"
                @click="
                purchase(scope.row.orderCode),
                purchaseInfo(scope.row.orderCode),
                getSupplier()"
              >采购</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page_box clearfix">
        <div class="page">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="15"
            :current-page.sync="page"
            @current-change="setPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 确认采购 -->
    <el-dialog title="确认采购" :visible.sync="show_purchase_form" width="80%">
      <el-form>
        <el-form-item label="订单编号:">
          <el-input
            style="width:500px"
            v-model="purchase_orderCode"
            autocomplete="off"
            :disabled="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-table :data="purchaseData" border type="index" style="width: 100%">
          <el-table-column prop="title" label="名称"></el-table-column>
          <el-table-column prop="item_no" label="货号"></el-table-column>
          <el-table-column prop="specification" label="规格"></el-table-column>
          <el-table-column prop="brand" label="品牌"></el-table-column>
          <el-table-column prop="inventory" label="库存" width="50"></el-table-column>
          <el-table-column label="供应商" width="250">
            <template slot-scope="scope">
              <el-autocomplete
                style="width:100%"
                v-model="purchaseData[scope.$index].supplier"
                :fetch-suggestions="querySearchAsync"
                @select="supplierSelect"
              ></el-autocomplete>
            </template>
          </el-table-column>
          <el-table-column label="价格">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].purchasePrice"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="数量">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="到货期">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].days" placeholder="单位天"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="备注" width="250">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].remark"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="show_purchase_form = false">取 消</el-button>
        <el-button type="primary" @click="confirm_purchase()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "./../../assets/all.css";
export default {
  name: "wait_buy_order",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      username: this.$cookies.get("username"),
      token: this.$cookies.get("token"),
      tableData: [],
      page: 1,
      total: 0,
      show_purchase_form: false,
      purchaseData: [],
      purchase_orderCode: "",
      supplierSelect: [],
      restaurants: []
    };
  },
  created() {
    this.$store.state.topActiveId = 3;
    this.$store.state.leftTitle = "等待采购";
    this.geting();
  },
  methods: {
    getSupplier(name) {
      this.axios
        .get(this.serve + "/admin/get_supplier_list", {
          params: {
            name: name,
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          var data = res.data;
          console.log(data);
          if (data.status == "success") {
            var row = [];
            var data1 = data.data;
            for (var i in data1) {
              var a = {};
              a.value = data1[i];
              row[i] = a;
            }
            this.restaurants = row;
          } else {
            this.restaurants = [];
          }
        });
    },
    querySearchAsync(queryString, cb) {
      console.log(queryString);
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      cb(results);
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    confirm_purchase() {
      var qs = require("qs");
      var formData = {
        username: this.username,
        token: this.token,
        orderCode: this.purchase_orderCode,
        order_info: JSON.stringify(this.purchaseData)
      };
      this.axios
        .post(this.serve + "/admin/buy_product", qs.stringify(formData))
        .then(res => {
          if (res.data.status == "success") {
            this.show_purchase_form = false;
            this.geting(this.page);
            this.$message({
              type: "success",
              message: "采购成功!",
              offset: 200
            });
          } else if (res.data.status == "error") {
            this.$message({
              type: "error",
              message: res.data.msg,
              offset: 200
            });
          }
        });
    },
    setPage(v) {
      this.geting(v);
      this.page = v;
    },
    purchase(orderCode) {
      this.purchase_orderCode = orderCode;
      this.show_purchase_form = true;
    },
    purchaseInfo(orderCode) {
      this.axios
        .get(this.serve + "/admin/purchaseInfo", {
          params: {
            username: this.username,
            token: this.token,
            orderCode: orderCode
          }
        })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            this.purchaseData = data.data;
          } else {
            this.purchaseData = [];
          }
        });
    },
    geting(page = 1) {
      var where = {
        username: this.username,
        token: this.token,
        page: page
      };
      this.axios
        .get(this.serve + "/admin/wait_buy_order", {
          params: where
        })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            this.tableData = data.data.results;
            this.total = data.data.total;
          } else {
            if(data.msg == "无权访问"){
              this.role =  false
            }
            this.tableData = [];
          }
        });
    }
  }
};
</script>

<style  lang="scss">
</style>